export const SocketsRoutes = {
  AUTHORIZE_WEBSOCKET_CONNECTION: '/broadcasting/auth'
};

export const NotificationsRoutes = {
  USER_NOTIFICATIONS: (id) => `private-companies.${id}`,
  SUPPLIER_NOTIFICATIONS: (id) => `private-suppliers.${id}`
};
